<template>
  <button
    class="btn"
    :class="{'btn--grey' : this.back}"
    :disabled="!enabled"
    @click="changeStep"
    :aria-label="text"
    :title="text"
  >{{text}}</button>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    back: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Continue'
    },
    stepAmount: {
      type: Number,
      default: 1
    },
    stepBackAmount: {
      type: Number,
      default: 1
    },
    isFirstPage: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    changeStep() {
      window.scroll(0, 0);

      if (this.back) {
        this.$emit('beforePrevStep');

        if (this.isFirstPage) {
          window.history.back();
        } else {
          this.$store.commit('checkout/prevStep', this.stepBackAmount);
        }
      } else {
        this.$emit('beforeNextStep');
        this.$store.commit('checkout/nextStep', this.stepAmount);
      }
    }
  }
};
</script>